import { IconProps } from "./types";
import React from "react";

export const InfoIcon = ({
  className,
  fill = "currentColor",
  width = 11,
  height = 10,
  style = {},
  onClick,
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 11 10"
    className={className}
    style={style}
    onClick={onClick}
    fill="none"
  >
    <path
      d="M5.20942 0C4.1791 0 3.17191 0.293245 2.31522 0.842652C1.45854 1.39206 0.790835 2.17295 0.396546 3.08658C0.00225719 4.00021 -0.100907 5.00555 0.1001 5.97545C0.301107 6.94535 0.797256 7.83627 1.52581 8.53553C2.25436 9.23479 3.18259 9.711 4.19312 9.90392C5.20365 10.0968 6.25109 9.99783 7.20298 9.61939C8.15488 9.24096 8.96848 8.60009 9.5409 7.77785C10.1133 6.9556 10.4188 5.9889 10.4188 5C10.4173 3.67436 9.86801 2.40343 8.89138 1.46606C7.91475 0.528691 6.59059 0.00144379 5.20942 0ZM5.73037 7.50636H4.68848V4.50636H5.73037V7.50636ZM5.73037 3.50636H4.68848V2.50636H5.73037V3.50636Z"
      fill={fill}
    />
  </svg>
);
